module.exports = __webpack_public_path__ + "img/pscBox3bg1.9c589e46.png";